import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
  useContext,
} from "react";
import { AuthContext } from "../../context/AuthContext";
import Grid from "@mui/material/Grid2";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import {
  Box,
  Divider,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { useSnackbar } from "notistack";
import PulseLoader from "react-spinners/PulseLoader";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { getDataWithToken } from "../../services/GetDataService";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";

import Checkbox from "@mui/material/Checkbox";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextEditor from "../../utils/TextEditor";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { TableContainer } from "@mui/material";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import {
  customerTypeList,
  designationList,
  paymentStatusList,
  purchaseStatusList,
  ratingList,
  roleList,
} from "../../data";
import { handlePostData } from "../../services/PostDataService";
import BarcodeGenerate from "../../utils/BarcodeGenerate";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "16px 24px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#EAECF0",
  borderStyle: "dashed",
  backgroundColor: "#fff",
  // color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out",
  borderRadius: "12px",
};

const focusedStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#F9FAFB",
  padding: "16px 12px",
  borderRadius: "8px !important",
  border: "1px solid #EAECF0",
  cursor: "pointer",
}));
const StockSkuList = ({}) => {
  const navigate = useNavigate();
  const { login, ifixit_admin_panel, logout } = useContext(AuthContext);
  const [addDialog, setAddDialog] = useState(false);
  const [supplierList, setSupplierList] = useState([]);
  const [supplier, setSupplier] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [branch, setBranch] = useState("");
  const [purchaseStatus, setPurchaseStatus] = useState("");
  const [paymentStatus, setPaymentStatus] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);
  const [shippingCharge, setShippingCharge] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [searchProductText, setsearchProductText] = useState("");
  const [productList, setProductList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [purchaseBy, setPurchaseBy] = useState("");
  const [userList, setUserList] = useState([]);

  const [brandId, setBrandId] = useState([]);
  const [categoryId, setCategoryId] = useState([]);
  const [deviceId, setDeviceId] = useState([]);
  const [modelId, setModelId] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const [modelList, setModelList] = useState([]);

  const [price, setPrice] = useState("");
  const [file, setFile] = useState(null);
  const [remarks, setRemarks] = useState("");

  const [loading2, setLoading2] = useState(false);
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [details, setDetails] = useState("");
  const [limitDataList, setLimitDataList] = useState();
  const [limitDataLoading, setLimitDataLoading] = useState(false);
  const [productData, setProductData] = useState({});
  const [generateSkuData, setGenerateSkuData] = useState({});
  const [skuProductName, setSkuProductName] = useState("");
  const [skuLoading, setSkuLoading] = useState(false);
  const [skuList, setSkuList] = useState([]);
  const [generateSKULoading, setGenerateSKULoading] = useState(false);
  const [stockStatus, setStockStatus] = useState("");
  const [scanInput, setScanInput] = useState("");
  const [scannedSkuList, setScannedSkuList] = useState([]);
  const scanInputRef = useRef(null);

  const { enqueueSnackbar } = useSnackbar();

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const clearFilter = () => {
    setBrandId("");
    setCategoryId("");
    setDeviceId("");
    setModelId("");

    setBranch("");
    setStockStatus("");
    setSkuList([]);
    setMessage("");
    setScanInput("");
    setScannedSkuList([]);
  };
  const customeTextFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    // padding: "15px 20px",

    // "& label.Mui-focused": {
    //   color: "#A0AAB4",
    // },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "15px 24px 15px 0px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };
  const custopDatePickerFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& .MuiInputBase-root": {
      fontSize: "0.875rem", // Adjust font size for a smaller appearance
      height: "2.5rem",
    },

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },

    "& .MuiOutlinedInput-input": {
      // padding: "10px 16px", (uncomment if needed)
    },

    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px", (uncomment if needed)
      "& fieldset": {
        borderColor: "#", // Update with a specific color if needed
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };
  const customeSelectFeild = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      // padding: "10px 16px",
    },
    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "#",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };
  const customeSelectFeildSmall = {
    boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
    background: "#ffffff",

    "& label.Mui-focused": {
      color: "#E5E5E5",
    },

    "& .MuiInput-underline:after": {
      borderBottomColor: "#B2BAC2",
    },
    "& .MuiOutlinedInput-input": {
      padding: "6px 16px",
      fontSize: "14px",
    },

    "& .MuiOutlinedInput-root": {
      // paddingLeft: "24px",
      "& fieldset": {
        borderColor: "#",
      },

      "&:hover fieldset": {
        borderColor: "#969696",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#969696",
      },
    },
  };

  const getBrandList = async () => {
    setLoading2(true);

    let url = `/api/v1/brand/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setBrandList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getBranchList = async () => {
    setLoading2(true);

    let url = `/api/v1/branch/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      let newBranchWithLimit = allData?.data?.data?.map((item) => ({
        ...item,
        limit: "",
      }));
      console.log("newBranchWithLimit", newBranchWithLimit);

      setBranchList(newBranchWithLimit);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getCategoryList = async () => {
    setLoading2(true);

    let url = `/api/v1/category/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setCategoryList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };

  const getDeviceList = async () => {
    setLoading2(true);

    let url = `/api/v1/device/dropdownlist`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data?.data", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setDeviceList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  const getModelList = async (id) => {
    setLoading2(true);

    let url = `/api/v1/model/device-model?deviceId=${id}`;
    // let url = `/api/v1/model/dropdownlist`;
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setModelList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLoading2(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setLoading2(false);
  };
  const getBranchLimit = async (product_variation_id) => {
    setLimitDataLoading(true);

    // let url = `/api/v1/model/device-model?deviceId=${id}`;
    let url = `/api/v1/stockCounterAndLimit/branch-limit?product_variation_id=${product_variation_id}`;
    let data = { product_variation_id };
    let allData = await getDataWithToken(url);
    if (allData?.status === 401) {
      logout();
      return;
    }

    if (allData.status >= 200 && allData.status < 300) {
      setLimitDataLoading(false);
      // setModelList(allData?.data?.data);

      let newBranchList = branchList?.map((item) => {
        let newData = allData?.data?.data?.find(
          (el) => el.branch_id === item?._id,
        );
        return { ...item, limit: newData?.stock_limit || 0 }; // Defaults to 0 if stock_limit is undefined
      });

      setBranchList(newBranchList);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setLimitDataLoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
  };

  const getProducts = async (searchText, bId, dId, mId, catId) => {
    setSearchLoading(true);
    let url;
    let newSearchProductText = searchProductText;
    let newBrandId = brandId;
    let newDeviceId = deviceId;
    let newModelId = modelId;
    let newCategoryId = categoryId;
    if (searchText) {
      newSearchProductText = searchText;
    }
    if (bId) {
      newBrandId = bId;
    }
    if (dId) {
      newDeviceId = dId;
    }
    if (mId) {
      newModelId = mId;
    }
    if (catId) {
      newCategoryId = catId;
    }

    url = `/api/v1/product?name=${newSearchProductText.trim()}&category_id=${newCategoryId}&brand_id=${newBrandId}&device_id=${newDeviceId}&model_id=${newModelId}&limit=1000`;

    let allData = await getDataWithToken(url);
    console.log("(allData?.data?.data products", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      setProductList(allData?.data?.data);

      if (allData.data.data.length < 1) {
        setMessage("No data found");
      }
    } else {
      setSearchLoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setSearchLoading(false);
  };

  const getSKU = async (item) => {
    console.log("item", item);

    // setGenerateSkuData(item);
    // setSkuProductName(
    //   item?.product_details[0]?.name +
    //     " - " +
    //     item?.product_variation_details[0]?.name,
    // );
    setSkuLoading(true);

    let url;
    let newSearchProductText = searchProductText;
    let newBrandId = brandId;
    let newDeviceId = deviceId;
    let newModelId = modelId;
    let newCategoryId = categoryId;
    let newBranch = branch;
    let newStockStatus = stockStatus;

    if (brandId) {
      newBrandId = brandId;
    }
    if (deviceId) {
      newDeviceId = deviceId;
    }
    if (modelId) {
      newModelId = modelId;
    }
    if (categoryId) {
      newCategoryId = categoryId;
    }
    if (branch) {
      newBranch = branch;
    }
    if (stockStatus) {
      newStockStatus = stockStatus;
    }
    setSkuList([]);
    setScannedSkuList([]);
    setScanInput("");

    url = `/api/v1/stock/stock-skus-details?sku_number=${encodeURIComponent(
      "",
    )}&stock_status=${newStockStatus}&branch_id=${newBranch}&category_id=${newCategoryId}&brand_id=${newBrandId}&device_id=${newDeviceId}&model_id=${newModelId}`;
    // let url = `/api/v1/stock/stock-skus-details?sku_number=${encodeURIComponent(
    //   ""
    // )}&stock_status=${encodeURIComponent("")}&product_id=${encodeURIComponent(
    //   item.product_id
    // )}&product_variation_id=${encodeURIComponent(
    //   item.product_variation_id
    // )}&branch_id=${encodeURIComponent(
    //   tableDataList[0]?.branch_id
    // )}&purchase_id=${encodeURIComponent(
    //   item.purchase_id
    // )}&purchase_product_id=${encodeURIComponent(item._id)}`;
    let allData = await getDataWithToken(url);
    console.log("allData?.data?.data", allData?.data?.data);
    if (allData?.status === 401) {
      logout();
      return;
    }
    if (allData.status >= 200 && allData.status < 300) {
      const skuData = allData?.data?.data ?? [];
      setSkuList(skuData);
      setGenerateSkuData({});
      if (skuData.length < 1) {
        setMessage("No data found");
      } else {
        setMessage("");
      }
    } else {
      setSkuLoading(false);
      setGenerateSkuData({});
      setGenerateSKULoading(false);
      handleSnakbarOpen(allData?.data?.message, "error");
    }
    setSkuLoading(false);
  };

  const handleScanSku = (skuValue) => {
    const trimmed = String(skuValue ?? "").trim();
    if (!trimmed) return;

    if (skuList.length < 1) {
      handleSnakbarOpen("Please search for SKUs first", "error");
      setScanInput("");
      scanInputRef.current?.focus();
      return;
    }

    const skuNumber = parseInt(trimmed, 10);
    if (Number.isNaN(skuNumber)) {
      handleSnakbarOpen("Invalid SKU number", "error");
      setScanInput("");
      scanInputRef.current?.focus();
      return;
    }

    const alreadyScanned = scannedSkuList.some(
      (item) => parseInt(item.sku_number, 10) === skuNumber,
    );

    if (alreadyScanned) {
      handleSnakbarOpen("This SKU is already scanned", "error");
      setScanInput("");
      scanInputRef.current?.focus();
      return;
    }

    const matchedSku = skuList.find(
      (item) => parseInt(item.sku_number, 10) === skuNumber,
    );

    if (!matchedSku) {
      handleSnakbarOpen("SKU not found in the list", "error");
      setScanInput("");
      scanInputRef.current?.focus();
      return;
    }

    setScannedSkuList((prev) => [...prev, matchedSku]);
    setSkuList((prev) =>
      prev.filter((item) => parseInt(item.sku_number, 10) !== skuNumber),
    );
    handleSnakbarOpen("SKU scanned successfully", "success");
    setScanInput("");
    scanInputRef.current?.focus();
  };

  const handleSelectedProduct = (item, product_data) => {
    console.log("item", item);
    setProductData(product_data);
    setDetails(item);
    getBranchLimit(item?._id);
    setAddDialog(true);

    // if (selectedProducts.some((res) => res._id === item._id)) {
    //   setSelectedProducts(
    //     selectedProducts.filter((res) => res._id !== item._id)
    //   );
    // } else {
    //   setSelectedProducts([
    //     ...selectedProducts,
    //     {
    //       ...item,
    //       product_id: item.product_id,
    //       product_variation_id: item._id,
    //       purchase_product_status: "",
    //       quantity: "",
    //       unit_price: "",
    //     },
    //   ]);
    // }
  };

  useEffect(() => {
    // getDropdownList();
    getCategoryList();
    getBrandList();
    getDeviceList();
    // getModelList();

    getBranchList();
  }, []);
  return (
    <>
      <Box container sx={{ padding: "24px 0" }}>
        <Typography
          variant="h6"
          gutterBottom
          component="div"
          sx={{ color: "#0F1624", fontWeight: 600 }}
        >
          Stock Audit List
        </Typography>
      </Box>

      <div
        style={{
          background: "#fff",
          border: "1px solid #EAECF1",
          borderRadius: "12px",
          overflow: "hidden",
          padding: "20px",
          boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
        }}
      >
        <Grid container justifyContent="right" spacing={2}>
          {/* <Grid size={4}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Search Product *
            </Typography>
            <TextField
              size="small"
              fullWidth
              id="searchProductText"
              placeholder="Search Product"
              variant="outlined"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17.5 17.5L13.875 13.875M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                          stroke="#85888E"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </InputAdornment>
                  ),
                },
              }}
              sx={{ ...customeTextFeild }}
              value={searchProductText}
              onChange={(e) => {
                setsearchProductText(e.target.value);
                getProducts(e.target.value);
              }}
            />
          </Grid> */}

          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Branch
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {branch === "" && (
                <InputLabel
                  id="branch-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Branch
                </InputLabel>
              )}
              <Select
                labelId="branch-select-label"
                id="branch"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                    },
                  },
                }}
                value={branch}
                onChange={(e) => {
                  setBranch(e.target.value);
                  // getProducts(null, e.target.value);
                }}
              >
                {branchList?.map((item) => (
                  <MenuItem key={item?._id} value={item?._id}>
                    {item?.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Stock Status
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {stockStatus === "" && (
                <InputLabel
                  id="stock-status-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Stock Status
                </InputLabel>
              )}
              <Select
                labelId="stock-status-select-label"
                id="stockStatus"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250,
                    },
                  },
                }}
                value={stockStatus}
                onChange={(e) => {
                  setStockStatus(e.target.value);
                }}
              >
                {["Attached", "Returned", "Available", "Abnormal"].map(
                  (item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ),
                )}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Brand
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {brandId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Brand
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="brandId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={brandId}
                // onChange={(e) => setBrandId(e.target.value)}

                onChange={(e) => {
                  setBrandId(e.target.value);
                  // getProducts(null, e.target.value);
                }}
              >
                {brandList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Device
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {deviceId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Device
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="deviceId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={deviceId}
                // onChange={(e) => setBrandId(e.target.value)}

                onChange={(e) => {
                  setDeviceId(e.target.value);
                  getModelList(e.target.value);
                  // getProducts(null, null, e.target.value);
                }}
              >
                {deviceList
                  .filter((item) => !item.name.toLowerCase().includes("series"))
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Model
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {modelId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Model
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="modelId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={modelId}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setModelId(e.target.value);
                  // getProducts(null, null, null, e.target.value);
                }}
              >
                {modelList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={2}>
            <Typography
              variant="medium"
              color="text.main"
              gutterBottom
              sx={{ fontWeight: 500 }}
            >
              Category
            </Typography>

            <FormControl
              fullWidth
              size="small"
              sx={{
                ...customeSelectFeild,
                "& label.Mui-focused": {
                  color: "rgba(0,0,0,0)",
                },

                "& .MuiOutlinedInput-input img": {
                  position: "relative",
                  top: "2px",
                },
              }}
            >
              {categoryId?.length < 1 && (
                <InputLabel
                  id="demo-simple-select-label"
                  sx={{ color: "#b3b3b3", fontWeight: 300 }}
                >
                  Select Category
                </InputLabel>
              )}
              <Select
                labelId="demo-simple-select-label"
                id="categoryId"
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 250, // Set the max height here
                    },
                  },
                }}
                value={categoryId}
                // onChange={(e) => setCategoryId(e.target.value)}

                onChange={(e) => {
                  setCategoryId(e.target.value);
                  // getProducts(null, null, null, null, e.target.value);
                }}
              >
                {categoryList
                  ?.filter((obj) => obj.name !== "Primary")
                  ?.map((item) => (
                    <MenuItem key={item?._id} value={item?._id}>
                      {item?.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, sm: 12, md: 4, lg: 2.4, xl: 2 }}>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={{ lg: 1, xl: 1 }}>
                <Grid size={4}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="info"
                    disableElevation
                    size="small"
                    sx={{ py: "4px" }}
                    onClick={clearFilter}
                  >
                    <RestartAltIcon />
                  </Button>
                </Grid>
                <Grid size={8}>
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    color="info"
                    sx={{ py: "4px" }}
                    size="small"
                    disabled={skuLoading}
                    startIcon={<SearchIcon />}
                    onClick={(event) => getSKU()}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>

        <Box
          sx={{
            background: "#fff",
            border: "1px solid #EAECF1",
            borderRadius: "12px",

            padding: "16px",
            boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
            marginTop: "20px",
          }}
        >
          <Typography variant="base" gutterBottom sx={{ fontWeight: 500 }}>
            SKU and Barcode &nbsp;
            {skuList?.length > 0 && ` (${skuList?.length})`}
          </Typography>
          {skuLoading && (
            <Box sx={{ width: "100%", mt: 1 }}>
              <LinearProgress color="info" />
            </Box>
          )}

          {!skuLoading && message && (
            <Typography
              variant="body1"
              sx={{ textAlign: "center", py: 2, color: "text.secondary" }}
            >
              <strong>{message}</strong>
            </Typography>
          )}

          <BarcodeGenerate list={skuList} showVarientName />
        </Box>

        <Box
          sx={{
            background: "#fff",
            border: "1px solid #EAECF1",
            borderRadius: "12px",
            padding: "16px",
            boxShadow: "0px 1px 2px 0px rgba(15, 22, 36, 0.05)",
            marginTop: "20px",
          }}
        >
          <Typography variant="base" gutterBottom sx={{ fontWeight: 500 }}>
            Scan Barcode
            {(skuList.length > 0 || scannedSkuList.length > 0) &&
              ` (${scannedSkuList.length} / ${skuList.length + scannedSkuList.length})`}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Scan barcodes from the list above to verify stock
          </Typography>

          <Grid container spacing={2} alignItems="center">
            <Grid size={{ xs: 12, md: 8 }}>
              <TextField
                inputRef={scanInputRef}
                size="small"
                fullWidth
                id="scanSkuInput"
                placeholder="Scan or enter SKU number"
                variant="outlined"
                value={scanInput}
                disabled={skuList.length < 1}
                sx={{ ...customeTextFeild }}
                onChange={(e) => setScanInput(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleScanSku(e.target.value);
                  }
                }}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
              <Button
                fullWidth
                variant="outlined"
                color="info"
                size="small"
                sx={{ py: 1 }}
                disabled={scannedSkuList.length < 1}
                onClick={() => {
                  setSkuList((prev) =>
                    [...prev, ...scannedSkuList].sort(
                      (a, b) => a.sku_number - b.sku_number,
                    ),
                  );
                  setScannedSkuList([]);
                  setScanInput("");
                  scanInputRef.current?.focus();
                }}
              >
                Clear Scanned
              </Button>
            </Grid>
          </Grid>

          {scannedSkuList.length > 0 && (
            <TableContainer sx={{ mt: 2, maxHeight: 300 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>SKU Number</TableCell>
                    <TableCell>Variation</TableCell>
                    <TableCell>Stock Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {scannedSkuList.map((item, index) => (
                    <TableRow key={`${item.sku_number}-${index}`}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.sku_number}</TableCell>
                      <TableCell>
                        {item?.product_variation_data?.[0]?.name || "-"}
                      </TableCell>
                      <TableCell>{item?.stock_status || "-"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {skuList.length === 0 && scannedSkuList.length > 0 && (
            <Typography
              sx={{
                textAlign: "center",
                color: "success.main",
                mt: 2,
                fontWeight: 500,
              }}
            >
              All SKUs scanned successfully
            </Typography>
          )}
        </Box>
      </div>
    </>
  );
};

export default StockSkuList;
